import * as requestFromServer from "./PersonnelsCrud";
import { callTypes, personnelSlice } from "./PersonnelsSlice";

const {actions} = personnelSlice;

export const getPersonnels = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getPersonnels(queryParams)
    .then(response => {
      dispatch(actions.personnelsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllPersonnels = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllPersonnels(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getPersonnelTypes = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getPersonnelTypes()
    .then(response => {
      dispatch(actions.personnelTypesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getPersonnel = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewPersonnel()
    .then(response => {
      dispatch(actions.personnelFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getPersonnel(id)
    .then(response => {
      dispatch(actions.personnelFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const savePersonnel = personnel => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .savePersonnel(personnel)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const renewContracts = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .renewContracts(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const deletePersonnels = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deletePersonnels(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const deleteContracts = (term, ids) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteContracts(term, ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanPersonnelsState = () => dispatch => {
  dispatch(actions.personnelsStateCleaned());
}